import { createContext, useEffect, useRef, useState } from "react";
import { useWSClient } from "../../api/WSClient";

/**
 * React context for WebSocket client.
 * Provides connection status and subscription controls.
 * @type {React.Context}
 */
const WebSocketContext = createContext();

/**
 * WebSocketProvider component to manage WebSocket connection lifecycle and subscriptions.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components wrapped by the provider.
 * @returns {JSX.Element}
 */
function WebSocketProvider({ children }) {
  /**
   * isConnected - connection status
   * setConnectionStatus - setter function
   */
  const [isConnected, setIsConnected] = useState(false); // Use state to track connection status

  /** Callback refs for error, success, and timeout events */
  const callbackError = useRef(null);
  const callbackSuccess = useRef(null);
  const callbackTimeout = useRef(null);

  /**
   * Register an error callback.
   * @param {Function} callback - Called on WebSocket errors.
   */
  const onError = (callback) => {
    callbackError.current = callback;
  };

  /**
   * Register a connection success callback.
   * @param {Function} callback - Called when connection is successful.
   */
  const onSuccess = (callback) => {
    callbackSuccess.current = callback;
  };

  /**
   * Register a timeout callback.
   * @param {Function} callback - Called when a timeout occurs.
   */
  const onTimeout = (callback) => {
    callbackTimeout.current = callback;
  };

  const {subscribe, unsubscribe}= useWSClient({
      stompAddress: process.env.REACT_APP_BROKER_URL
        ? `${process.env.REACT_APP_BROKER_URL}:${process.env.REACT_APP_BROKER_PORT}/ws`
        : "ws://192.168.10.139:15674/ws",
      onConnectionSuccess: () => {
        setIsConnected(true);
        //callbackSuccess?.current && callbackSuccess?.current();
      },
      receiveCallbackError: (error) => {
        //callbackError?.current && callbackError?.current(error);
      console.warn(error);
    },
  });
  
  return (
    <WebSocketContext.Provider
      value={[isConnected, /*onError, onSuccess,*/ subscribe, unsubscribe]}
    >
      {children}
    </WebSocketContext.Provider>
  );
}

export { WebSocketContext, WebSocketProvider };

